import dynamic from 'next/dynamic';

import { type SessionListHost } from '../session-list/session-list-host';
import { type SessionsListPanelProps } from '../sessions-list-panel/sessions-list-panel';
import { SessionsListLoading } from './side-nav-list/components/sessions-list-loading';

const sessionsBarFallback = ({ error }: { error?: Error | null }) => {
  if (error) throw error;
  return <SessionsListLoading />;
};

/**
 * Lazy boundaries for the three sessions-bar variants and the sessions list panel. A static re-export
 * would pull every variant's cone into the eager barrel.
 */
export const LazySessionsBar = dynamic<{ host: SessionListHost }>(
  () => import('./side-bar'),
  { loading: sessionsBarFallback }
);

export const LazySessionsBarV2 = dynamic<{ host: SessionListHost }>(
  () => import('../upcoming-session-tab/components/session-bar-v2'),
  { loading: sessionsBarFallback }
);

export const LazyConsolidatedSessionsBar = dynamic<{ host: SessionListHost }>(
  () => import('../consolidated-sessions-list/components/sessionBar'),
  { loading: sessionsBarFallback }
);

export const LazySessionsListPanel = dynamic<
  SessionsListPanelProps & { host: SessionListHost }
>(() =>
  import('../sessions-list-panel/sessions-list-panel').then((m) => m.SessionsListPanel)
);
